export interface Props {
  name: string;
  img: string;
  numberImg?: number;
  view?: number;
  onClick?: () => void;
}

function ItemLocation({
  name,
  img,
  numberImg,
  view,
  onClick = () => {},
}: Props) {
  return (
    <div className="--item itemLocation link" onClick={onClick}>
      {img && (
        <div className="--imgLct">
          <img src={img} alt="" />
        </div>
      )}
      <div className="--totalImg">
        <i className="fa-regular fa-image"></i>
        <span>{numberImg}</span>
      </div>

      <div className="--titleLct">
        <h6 className="--nameLct">{name}</h6>
        {view && (
          <div className="--viewLct">
            <div className="--iconLct">
              <img src="/static/img/icon-eye.svg" alt="" />
            </div>
            <span>{view}</span>
          </div>
        )}
      </div>
    </div>
  );
}
export default ItemLocation;
